import * as React from "react";
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { useState, useEffect } from 'react';
import { fetchAccountDetails } from "../store/accountSlice";
import { useDispatch, useSelector } from "react-redux";

let data0 = [
  "Prashant Kumar",
  "Support Executive",
  8700534108,
  "prashant@meon.co.in",
];

let data1 = [
  "Shubham Shukla",
  "Support Executive",
  8851678197,
  "shubham.shukla@meon.co.in",
];

let data2 = [
  "Priyanka Kumari",
  "EIPO and Account Closure Support",
  8826606770,
  "priyanka.kumari@meon.co.in"
]

let data3 = [
  "Dushyant Sharma",
  "Rekyc Support",
  9310579420,
  "dushyant@meon.co.in"
]

export default function Escalation() {
  const [accountDetails, setAccountDetails] = useState({
    customer_name: '',
    customer_id: '',
    products: '',
    client_status: ''
  });

  const dispatch = useDispatch();
  const {
    data,
    customer_name,
    customer_id,
    products,
    contact_person,
    contact_email,
    contact_number,
    session_response,
    session_flag,
    status,
    error
  } = useSelector((state) => state.account)

  useEffect(() => {
    dispatch(fetchAccountDetails());
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      if (session_flag) {
        // setSessionResponse(session_response);
        // setSessionFlag(true);
      } else {
        setAccountDetails(data);
        // setEmail(contact_email);
        // setContactPerson(contact_person);
        // setContactNumber(contact_number);
      }
    }
  }, [data]);


  // useEffect(() => {
  //   const fetchAccountDetails = async () => {
  //     try {
  //       const response = await fetch('/meonsupport/account_detail', {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       });
  //       const data = await response.json();
  //       setAccountDetails(data);
  //     } catch (error) {
  //     }
  //   };

  //   fetchAccountDetails();
  // }, []);

  return (
    <Wrapper>
      <Helmet>
        <title>Escalation Matrix | Support Tool</title>
      </Helmet>
      <Typography variant="h4" sx={{ mb: 5, ml: 1, color: "#103996" }}>
        Escalation Matrix
      </Typography>
      <Box className="tableClass">
        <Table className="table">
          <Thead>
            <Tr>
              <Th>Person responsible</Th>
              <Th>Role</Th>
              <Th>Contact No.</Th>
              <Th>Email</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              {data0.map((item, index) => {
                return <Td key={index}>{item}</Td>;
              })}
            </Tr>
            <Tr>
              {data1.map((item, index) => {
                return <Td key={index}>{item}</Td>;
              })}
            </Tr>
            {(products.includes('EIPO') || products.includes('Account Closure')) && (
              <Tr>
                {data2.map((item, index) => {
                  return <Td key={index}>{item}</Td>;
                })}
              </Tr>
            )}
            {(products.includes('rekyc')) && (
              <Tr>
                {data3.map((item, index) => {
                  return <Td key={index}>{item}</Td>;
                })}
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  table {
    border-collapse: collapse;
    width: 100%;
  }

  th,
  td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
  }
  .tableClass {
    height: 63vh;
  }
  @media only screen and (max-width: 768px) {
    margin-bottom: 55px;
    .tableClass {
      height: 80vh;
    }
  }
`;
